import { Link } from 'react-router-dom';
import SEO from '@/components/common/SEO';
import { DISCLOSURES } from '@/content/financial/editorial';

export default function Disclosures() {
  return (
    <div className="bg-white dark:bg-surface-dark">
      <SEO
        title="Financial Disclosures"
        description="Educational-use disclosure, affiliate policy, cross-border tax caveats, and the limits of the tools and content in the Financial section."
        path="/financial/disclosures"
      />

      <div className="mx-auto max-w-2xl px-4 py-14 sm:px-6 sm:py-20">
        <nav aria-label="Breadcrumb" className="mb-4 text-sm text-ink-500 dark:text-ink-400">
          <Link to="/financial" className="hover:underline">
            Financial
          </Link>
          <span className="mx-2" aria-hidden="true">
            /
          </span>
          <span className="text-ink-700 dark:text-ink-200">Disclosures</span>
        </nav>

        <p className="text-[11px] font-bold uppercase tracking-wide text-cheong-500 dark:text-cheong-dark">
          Disclosures
        </p>
        <h1 className="mt-3 text-3xl font-bold leading-tight text-ink-900 dark:text-ink-50 sm:text-4xl">
          Disclosures
        </h1>
        <p lang="ko" className="mt-1 font-korean text-lg text-ink-500 dark:text-ink-400">
          고지 사항
        </p>
        <p className="mt-5 text-lg leading-8 text-ink-700 dark:text-ink-200">
          The plain-language version of what this section is, what it is not, and what you should
          not rely on it for.
        </p>

        <div className="mt-12 space-y-10">
          {DISCLOSURES.map((section) => (
            <section key={section.heading}>
              <h2 className="mb-3 text-lg font-semibold text-ink-900 dark:text-ink-50">
                {section.heading}
              </h2>
              <p className="leading-[1.75] text-ink-700 dark:text-ink-200">{section.body}</p>
            </section>
          ))}
        </div>

        <p className="mt-14 border-t border-ink-200 pt-6 text-sm leading-relaxed text-ink-500 dark:border-surface-dark-border dark:text-ink-400">
          For how each case study's figures were obtained, see the{' '}
          <Link
            to="/financial/methodology"
            className="font-medium text-cheong-500 underline dark:text-cheong-dark"
          >
            sourcing methodology
          </Link>
          .
        </p>
      </div>
    </div>
  );
}
